import { api } from "../api";

/**
 * devicefindAllCrudResponse - Function that finds on database all devices as crud response data    
 * /devices/{status}   
 * method GET 
 * @async-function
 */
const devicefindAllCrudResponse = async (token: string, managerId: number, status: string, page: number, size: number, search: string = "") => {
    const response = await api.get(
        `/devices/${managerId}/${status}?page=${page}&size=${size}&search=${search}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default devicefindAllCrudResponse;